// src/components/FilterForm.js
import React, { useState } from 'react';
import { useEffect } from 'react';
//import './FilterForm.css'; // Add necessary CSS

const FilterForm = ({ onApplyFilters, onCloseFilters, filters, initialPostCode, initaccreditations }) =>
{
  const [postcode, setPostcode] = useState(initialPostCode);
  const [keywordSearch, setKeywordSearch] = useState(filters?.keywordSearch || '');
  const [within, setWithin] = useState(filters?.within || '25km');
  const [accreditations, setAccreditations] = useState(initaccreditations);
  const [selectedAccreditations, setSelectedAccreditations] = useState(filters?.selectedAccreditations || []);

  // Always default workScope to true for residential, commercial, government
  const [workScope, setWorkScope] = useState({
    residential: true,
    commercial: true,
    government: true,
  });

  const [licensed, setLicensed] = useState(filters?.licensed || false);
  const [insured, setInsured] = useState(filters?.insured || false);
  const [ratings, setRatings] = useState(filters?.ratings || '4 stars +');
  const [options, setOptions] = useState({
    afterHours: true,
    weekends: false,
  });

  //const accreditationsList = ['Level 3', 'Level 2', 'Level 1', 'Metering', 'Overhead Connections'];


  useEffect(() =>
  {
    setPostcode(initialPostCode);
  }, [initialPostCode]);

  useEffect(() =>
  {
    setAccreditations(initaccreditations);
  }, [initaccreditations]);


  useEffect(() =>
  {
    setKeywordSearch(filters?.keywordSearch || '');
    setWithin(filters?.within || '25km');

    setSelectedAccreditations(filters.selectedAccreditations || []);

    setLicensed(filters?.licensed || false);
    setInsured(filters?.insured || false);
    setRatings(filters?.ratings || '3 stars +');

    setOptions({
      afterHours: filters?.options.afterHours ?? false,
      weekends: filters?.options.weekends ?? false,
    });

    // Merge default workScope with filters if they exist
    setWorkScope({
      residential: filters?.workScope?.residential ?? true,
      commercial: filters?.workScope?.commercial ?? true,
      government: filters?.workScope?.government ?? true,
    });
  }, [filters]);

  const handleAccreditationChange = (certificationId) =>
  {
    if (selectedAccreditations.includes(certificationId))
    { setSelectedAccreditations(selectedAccreditations.filter((id) => id !== certificationId)); }
    else { setSelectedAccreditations([...selectedAccreditations, certificationId]); }
  };



  const handleRatingChange = (e) =>
  {
    setRatings(e.target.value);
  };

  const handleWorkScopeChange = (e) =>
  {
    setWorkScope({ ...workScope, [e.target.name]: e.target.checked });
  };

  const handleOptionChange = (e) =>
  {
    setOptions({ ...options, [e.target.name]: e.target.checked });
  };

  // Ensure this method is called when the 'Apply Filters' button is pressed
  const handleApplyFilters = () =>
  {
    const filters = {
      postcode,
      within,
      keywordSearch,
      selectedAccreditations,
      workScope,  // Ensure workScope is passed
      ratings,
      options,
      licensed,
      insured
    };

    console.log('Applying filters:', filters);  // Debugging to see what is being passed
    onApplyFilters(filters); // Pass filters back to MapSearch
  };

  const handlePostCodeChange = (e) =>
  {
    if (/^\d{0,4}$/.test(e.target.value))
    {
      setPostcode(e.target.value);
    }
  }


  return (
    <div className="filter-form">

      <div className="filter-row">

        <div className="filter-section">
          <label>Postcode</label>
          <input
            type="text"
            value={postcode}
            onChange={handlePostCodeChange}
            className="input-field"
          />
        </div>

        <div className="filter-section">
          <label>Within</label>
          <select
            value={within}
            onChange={(e) => setWithin(e.target.value)}
            className="input-field"
          >
            <option>5km</option>
            <option>10km</option>
            <option>25km</option>
            <option>50km</option>
          </select>
        </div>
      </div>

      {/* <div className="filter-section">
        <label>Looking For</label>
        <select className="input-field">
          <option>Electrician</option>
          <option>Electrician</option>
          <option>Electrician</option>
          <option>Electrician</option>
        </select>
      </div> */}
      {/* <div className="filter-section">
        <label>Service</label>
        <textarea className="input-field" placeholder="Install new metering and powerpole" />
      </div> */}

      <div className="filter-section">
        <label>Keyword Search</label>
        <textarea
          value={keywordSearch}
          onChange={(e) => setKeywordSearch(e.target.value)}
          className="input-field"
          placeholder="Keywords to search business table columns"
        />
      </div>


      <div className="filter-main-row">

        <div className="filter-section">
          <label>Ratings</label>
          <div className="ratings custom-radiobox">
            <label>
              <input
                type="radio"
                value="5 stars"
                checked={ratings === '5 stars'}
                onChange={handleRatingChange}
              />
              <span>5 stars</span>
            </label>
            <label>
              <input
                type="radio"
                value="4 stars +"
                checked={ratings === '4 stars +'}
                onChange={handleRatingChange}
              />
              <span>4 stars +</span>
            </label>
            <label>
              <input
                type="radio"
                value="3 stars +"
                checked={ratings === '3 stars +'}
                onChange={handleRatingChange}
              />
              <span>3 stars +</span>
            </label>
            <label>
              <input
                type="radio"
                value="2 stars +"
                checked={ratings === '2 stars +'}
                onChange={handleRatingChange}
              />
              <span>2 stars +</span>
            </label>



          </div>
        </div>

        <div className="filter-section">
          <label>Work Scope</label>
          <div className="work-scope">
            <div className='custom-checkbox'>
              <label>
                <input
                  type="checkbox"
                  name="residential"
                  checked={workScope.residential}
                  onChange={handleWorkScopeChange}
                />
                <span>Residential</span>
              </label>
            </div>

            <div className='custom-checkbox'>
              <label>
                <input
                  type="checkbox"
                  name="commercial"
                  checked={workScope.commercial}
                  onChange={handleWorkScopeChange}
                />
                <span>Commercial</span>
              </label>
            </div>

            <div className='custom-checkbox'>
              <label>
                <input
                  type="checkbox"
                  name="government"
                  checked={workScope.government}
                  onChange={handleWorkScopeChange}
                />
                <span>Government</span>
              </label>
            </div>


          </div>
        </div>


      </div>



      <div className="filter-section">
        <label>Accreditations</label>
        <div className="accreditations scrollable-list">
          {accreditations?.map((acc) => (



            <div className='custom-checkbox'>
              <label key={acc.certificationId}>
                <input
                  type="checkbox"
                  value={acc.certificationId}
                  checked={selectedAccreditations.includes(acc.certificationId)}
                  onChange={() => handleAccreditationChange(acc.certificationId)}
                />
                <span>{acc.name}</span>
              </label>
            </div>
          ))}
        </div>
      </div>



      <div className="filter-main-row">

        <div className="filter-section">
          <div className='custom-checkbox'>
            <label>
              <input
                type="checkbox"
                name="afterHours"
                checked={options.afterHours}
                onChange={handleOptionChange}
              />
              <span>After hours</span>
            </label>
          </div>
        </div>
        <div className='filter-section'>
          <div className='custom-checkbox'>
            <label>
              <input
                type="checkbox"
                name="weekends"
                checked={options.weekends}
                onChange={handleOptionChange}
              />
              <span>Weekends</span>
            </label>
          </div>
        </div>
      </div>


      <div className='filter-main-row'>
        <div className="filter-section toggles">
          <label className='big-title'>Fully Insured</label>
          <label className="switch">
            <input
              type="checkbox"
              checked={insured}
              onChange={() => setInsured(!insured)}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="filter-section toggles">
          <label className='big-title'>Fully Lincensed</label>
          <label className="switch">
            <input
              type="checkbox"
              checked={licensed}
              onChange={() => setLicensed(!licensed)}
            />
            <span className="slider round"></span>
          </label>
        </div>

      </div>
      <button className="apply-filters-button" onClick={handleApplyFilters}>
        Apply filters
      </button>
    </div>
  );
};

export default FilterForm;